interface MaintenanceModalProps {
  message: string;
}

export function MaintenanceModal({ message }: MaintenanceModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md">
      <div className="mx-4 max-w-md rounded-xl border border-yellow-500/30 bg-[rgb(var(--card))]/95 backdrop-blur-sm p-8 shadow-2xl">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="flex items-center justify-center">
            <img 
              src="/logo-dark.avif" 
              alt="Nordex Logo" 
              className="h-8 w-auto object-contain"
            />
          </div>
          <h2 className="text-2xl font-bold text-[rgb(var(--foreground))]">Maintenance</h2>
          <p className="text-base text-[rgb(var(--foreground))]/90">
            {message || "Maintenance - Scheduled upgrade in progress."}
          </p>
          <p className="text-sm text-[rgb(var(--muted-foreground))]">
            Please check back in a few minutes. Thank you for your patience!
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm text-yellow-500">
            <div className="h-2 w-2 rounded-full bg-yellow-500 animate-pulse" />
            <span>Maintenance in progress...</span>
          </div>
        </div>
      </div>
    </div>
  );
}

